/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AccountOptionDto interface.
 */
export function instanceOfAccountOptionDto(value) {
    return true;
}
export function AccountOptionDtoFromJSON(json) {
    return AccountOptionDtoFromJSONTyped(json, false);
}
export function AccountOptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'idAccount': json['idAccount'] == null ? undefined : json['idAccount'],
        'nome': json['nome'] == null ? undefined : json['nome'],
    };
}
export function AccountOptionDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'idAccount': value['idAccount'],
        'nome': value['nome'],
    };
}
